import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// reactstrap components
import { Card, CardHeader, CardBody, FormGroup, Alert } from 'reactstrap';
import axios from 'utils/axios';
import * as Yup from 'yup';
import { createUseStyles } from 'react-jss';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { startsWith } from 'lodash-es';
import AntButton from 'antd/lib/button';
import 'antd/lib/button/style/index.css';
import ForgotPasswordModal from './ForgotPasswordModal';

const LoginSchema = Yup.object().shape({
  username: Yup.string().required('Required'),
});

/* ----------------Styles-------------- */
const useStyles = createUseStyles({
  signInButton: {
    width: '100%',
    backgroundColor: '#2675b8',
    color: 'white',
    '&:hover': {
      backgroundColor: '#2675b8',
      color: 'white',
    },
    border: 'none',
  },
  forgotPassword: {
    '&:hover': {
      textDecoration: 'underline',
      color: '#b4b5be',
    },
    paddingLeft: '3px',
    color: '#b4b5be',
  },
  createAccount: {
    '&:hover': {
      textDecoration: 'underline',
      color: '#b4b5be',
    },
    paddingRight: '3px',
    color: '#b4b5be',
  },
  phoneInput: {
    backgroundColor: 'black',
  },
  signinButton: {
    marginTop: '4px',
    height: '43px',
    backgroundColor: '#2675b8',
    width: '100%',
    color: 'white',
    border: 'none',
    '&:hover': {
      backgroundColor: '#2675b8!important',
      color: 'white!important',
    },
    '&:focus': {
      backgroundColor: '#2675b8!important',
      color: 'white!important',
    },
    borderRadius: '5px',
  },
});

const ForgotPassword = ({ phone }) => {
  const [error, setError] = useState('');
  const classes = useStyles();
  const [inputUsername, setInputUsername] = useState('');
  const [forgotPasswordModalOpen, setForgotPasswordModalOpen] = useState(false);
  const [resendCounter, setResendCounter] = useState(0);
  const [isSendingOTP, setSendingOTP] = useState(false);
  const toggleForgotPasswordModal = (val) =>
    setForgotPasswordModalOpen(
      val === 'open' ? true : !forgotPasswordModalOpen,
    );

  // const handleSubmit = async ({ username }, { setSubmitting = null }) => {
  const handleSubmit = async ({ username }) => {
    try {
      setError('');
      setSendingOTP(true);
      const formattedUsername = startsWith('+', username)
        ? username
        : `+${username}`;
      await axios.post('/users/forgotPassword', {
        username: formattedUsername,
      });
      setResendCounter(resendCounter + 1);
      setInputUsername(formattedUsername);
      toggleForgotPasswordModal('open');
    } catch (error) {
      setError('Failed to send OTP');
    } finally {
      setSendingOTP(false);
      // if (setSubmitting) setSubmitting(false);
    }
  };
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '445px',
          alignItems: 'center',
        }}
      >
        <Card
          className="bg-secondary shadow border-0"
          style={{ width: '100%' }}
        >
          <CardHeader className="">
            <div to="/" tag={Link} className="text-muted text-center mt-2 mb-3">
              <img
                alt="..."
                src={require('../../assets/companyLogo/jplogo.png').default}
                style={{ width: '200px' }}
              />
            </div>
          </CardHeader>
          <CardBody className="px-lg-5 py-lg-5">
            {error ? (
              <div className="text-center text-muted mb-4">
                <Alert className="m-3" variant="danger">
                  {error}
                </Alert>
              </div>
            ) : null}

            <Formik
              initialValues={{ username: phone }}
              onSubmit={handleSubmit}
              validationSchema={LoginSchema}
            >
              {({ values, isSubmitting, setFieldValue, handleSubmit }) => (
                <Form>
                  <FormGroup className="mb-3">
                    <PhoneInput
                      name="username"
                      country={'in'}
                      placeholder="Phone Number with country code"
                      value={values.username}
                      onChange={(phone) => setFieldValue('username', phone)}
                      inputStyle={{ width: '100%', height: '43px' }}
                      countryCodeEditable={false}
                      enableSearch={true}
                    />
                  </FormGroup>

                  <div className="text-center">
                    <AntButton
                      className={classes.signinButton}
                      loading={isSubmitting}
                      htmlType="submit"
                    >
                      Send me OTP
                    </AntButton>
                  </div>
                </Form>
              )}
            </Formik>
          </CardBody>
        </Card>
        <ForgotPasswordModal
          toggleForgotPasswordModalOpen={toggleForgotPasswordModal}
          forgotPasswordModalOpen={forgotPasswordModalOpen}
          username={inputUsername}
          resendPassword={handleSubmit}
          resendCounter={resendCounter}
          isSendingOTP={isSendingOTP}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '445px',
            marginTop: '15px',
          }}
        >
          <Link className={classes.createAccount} to="/auth/login">
            <small>Login instead?</small>
          </Link>

          <Link className={classes.createAccount} to="/auth/signup">
            <small>Create new account</small>
          </Link>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
